import type {Values} from "@wix/devzai-utils-common";

export const DoppeAutoProductType = {
    Latest: 'Latest'
} as const;

export type DoppeAutoProductType = Values<typeof DoppeAutoProductType>;